var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _ellipse111, _ellipse112, _ellipse113, _ellipse114, _ellipse115, _ellipse116, _ellipse117, _ellipse118, _ellipse119, _ellipse120, _ellipse121, _ellipse122, _ellipse123, _ellipse124, _ellipse125, _ellipse126, _ellipse127, _ellipse128, _ellipse129, _ellipse130, _ellipse131, _ellipse132, _ellipse133, _ellipse134, _ellipse135, _ellipse136, _ellipse137, _ellipse138, _ellipse139, _ellipse140, _ellipse141, _ellipse142, _ellipse143, _ellipse144, _ellipse145, _ellipse146, _ellipse147, _ellipse148, _ellipse149, _ellipse150, _ellipse151, _ellipse152, _ellipse153, _ellipse154, _ellipse155, _ellipse156, _ellipse157, _ellipse158, _ellipse159, _ellipse160, _ellipse161, _ellipse162, _ellipse163, _ellipse164, _ellipse165, _ellipse166, _ellipse167, _ellipse168, _ellipse169, _ellipse170, _ellipse171, _ellipse172, _ellipse173, _ellipse174, _ellipse175, _ellipse176, _ellipse177, _ellipse178, _ellipse179, _ellipse180, _ellipse181, _ellipse182, _ellipse183, _ellipse184, _ellipse185, _ellipse186, _ellipse187, _ellipse188, _ellipse189, _ellipse190, _ellipse191, _ellipse192, _ellipse193, _ellipse194, _ellipse195, _ellipse196, _ellipse197, _ellipse198, _ellipse199, _ellipse200, _ellipse201, _ellipse202, _ellipse203, _ellipse204, _ellipse205, _ellipse206, _ellipse207, _ellipse208, _ellipse209, _ellipse210, _ellipse211, _ellipse212, _ellipse213, _ellipse214, _ellipse215, _ellipse216, _ellipse217, _ellipse218, _ellipse219, _ellipse220, _ellipse221, _ellipse222, _ellipse223, _ellipse224, _ellipse225, _ellipse226, _ellipse227, _ellipse228, _ellipse229, _ellipse230, _ellipse231, _ellipse232, _ellipse233, _ellipse234, _ellipse235, _ellipse236, _ellipse237, _ellipse238, _ellipse239, _ellipse240, _ellipse241, _ellipse242, _ellipse243, _ellipse244, _ellipse245, _ellipse246, _ellipse247, _ellipse248, _ellipse249, _ellipse250, _ellipse251, _ellipse252, _ellipse253, _ellipse254, _ellipse255, _ellipse256, _ellipse257, _ellipse258, _ellipse259, _ellipse260, _ellipse261, _ellipse262, _ellipse263, _ellipse264, _ellipse265, _ellipse266, _ellipse267, _ellipse268, _ellipse269, _ellipse270, _ellipse271, _ellipse272, _ellipse273, _ellipse274, _ellipse275, _ellipse276, _ellipse277, _ellipse278, _ellipse279, _ellipse280, _ellipse281, _ellipse282, _ellipse283, _ellipse284, _ellipse285, _ellipse286, _ellipse287, _ellipse288, _ellipse289, _ellipse290, _ellipse291, _ellipse292, _ellipse293, _ellipse294, _ellipse295, _ellipse296, _ellipse297, _ellipse298, _ellipse299, _ellipse300, _ellipse301, _ellipse302, _ellipse303, _ellipse304, _ellipse305, _ellipse306, _ellipse307, _ellipse308, _ellipse309, _ellipse310, _ellipse311, _ellipse312, _ellipse313, _ellipse314, _ellipse315, _ellipse316, _ellipse317, _ellipse318, _ellipse319, _ellipse320, _ellipse321, _ellipse322, _ellipse323, _ellipse324, _ellipse325, _ellipse326, _ellipse327, _ellipse328, _ellipse329, _ellipse330, _ellipse331, _ellipse332, _ellipse333, _ellipse334, _ellipse335, _ellipse336, _ellipse337, _ellipse338, _ellipse339, _ellipse340, _ellipse341, _ellipse342, _ellipse343, _ellipse344, _ellipse345, _ellipse346, _ellipse347, _ellipse348, _ellipse349, _ellipse350, _ellipse351, _ellipse352, _ellipse353, _ellipse354, _ellipse355, _ellipse356, _ellipse357, _ellipse358, _ellipse359, _ellipse360, _ellipse361, _ellipse362, _ellipse363, _ellipse364, _ellipse365, _ellipse366, _ellipse367, _ellipse368, _ellipse369, _ellipse370, _ellipse371, _ellipse372, _ellipse373, _ellipse374, _ellipse375, _ellipse376, _ellipse377, _ellipse378, _ellipse379, _ellipse380, _ellipse381, _ellipse382, _ellipse383, _ellipse384, _ellipse385, _ellipse386, _ellipse387, _ellipse388, _ellipse389, _ellipse390, _ellipse391, _ellipse392, _ellipse393, _ellipse394, _ellipse395, _ellipse396, _ellipse397, _ellipse398, _ellipse399, _ellipse400, _ellipse401, _ellipse402, _ellipse403, _ellipse404, _ellipse405, _ellipse406, _ellipse407, _ellipse408, _ellipse409, _ellipse410, _ellipse411, _ellipse412, _ellipse413, _ellipse414, _ellipse415, _ellipse416, _ellipse417, _ellipse418, _ellipse419, _ellipse420, _ellipse421, _ellipse422, _ellipse423, _ellipse424, _ellipse425, _ellipse426, _ellipse427, _ellipse428, _ellipse429, _ellipse430, _ellipse431, _ellipse432, _ellipse433, _ellipse434, _ellipse435, _ellipse436, _ellipse437, _ellipse438, _ellipse439, _ellipse440, _ellipse441, _ellipse442, _ellipse443, _ellipse444, _ellipse445, _ellipse446, _ellipse447, _ellipse448, _ellipse449, _ellipse450, _ellipse451, _ellipse452, _ellipse453, _ellipse454, _ellipse455, _ellipse456, _ellipse457, _ellipse458, _ellipse459, _ellipse460, _ellipse461, _ellipse462, _ellipse463, _ellipse464, _ellipse465, _ellipse466, _ellipse467, _ellipse468, _ellipse469, _ellipse470, _ellipse471, _ellipse472, _ellipse473, _ellipse474, _ellipse475, _ellipse476, _ellipse477, _ellipse478, _ellipse479, _ellipse480, _ellipse481, _ellipse482, _ellipse483, _ellipse484, _ellipse485, _ellipse486, _ellipse487, _ellipse488, _ellipse489, _ellipse490, _ellipse491, _ellipse492, _ellipse493, _ellipse494, _ellipse495, _ellipse496, _ellipse497, _ellipse498, _ellipse499, _ellipse500, _ellipse501, _ellipse502, _ellipse503, _ellipse504, _ellipse505, _ellipse506, _ellipse507, _ellipse508, _ellipse509, _ellipse510, _ellipse511, _ellipse512, _ellipse513, _ellipse514, _ellipse515, _ellipse516, _ellipse517, _ellipse518, _ellipse519, _ellipse520, _ellipse521, _ellipse522, _ellipse523, _ellipse524, _ellipse525, _ellipse526, _ellipse527, _ellipse528, _ellipse529, _ellipse530, _ellipse531, _ellipse532, _ellipse533, _ellipse534, _ellipse535, _ellipse536, _ellipse537, _ellipse538, _ellipse539, _ellipse540, _ellipse541, _ellipse542, _ellipse543, _ellipse544, _ellipse545, _ellipse546, _ellipse547, _ellipse548, _ellipse549, _ellipse550, _ellipse551, _ellipse552, _ellipse553, _ellipse554, _ellipse555, _ellipse556, _ellipse557, _ellipse558, _ellipse559, _ellipse560, _ellipse561, _ellipse562, _ellipse563, _ellipse564, _ellipse565, _ellipse566, _ellipse567, _ellipse568, _ellipse569, _ellipse570, _ellipse571, _ellipse572, _ellipse573, _ellipse574, _ellipse575, _ellipse576, _ellipse577, _ellipse578, _ellipse579, _ellipse580, _ellipse581, _ellipse582, _ellipse583, _ellipse584, _ellipse585, _ellipse586, _ellipse587, _ellipse588, _ellipse589, _ellipse590, _ellipse591, _ellipse592, _ellipse593, _ellipse594, _ellipse595, _ellipse596, _ellipse597, _ellipse598, _ellipse599, _ellipse600, _ellipse601, _ellipse602, _ellipse603, _ellipse604, _ellipse605, _ellipse606, _ellipse607, _ellipse608, _ellipse609, _ellipse610, _ellipse611, _ellipse612, _ellipse613, _ellipse614, _ellipse615, _ellipse616, _ellipse617, _ellipse618, _ellipse619, _ellipse620, _ellipse621, _ellipse622, _ellipse623, _ellipse624, _ellipse625, _ellipse626, _ellipse627, _ellipse628, _ellipse629, _ellipse630, _ellipse631, _ellipse632, _ellipse633, _ellipse634, _ellipse635, _ellipse636, _ellipse637, _ellipse638, _ellipse639, _ellipse640, _ellipse641, _ellipse642, _ellipse643, _ellipse644, _ellipse645, _ellipse646, _ellipse647, _ellipse648, _ellipse649, _ellipse650, _ellipse651, _ellipse652, _ellipse653, _ellipse654, _ellipse655, _ellipse656, _ellipse657, _ellipse658, _ellipse659, _ellipse660, _ellipse661, _ellipse662, _ellipse663, _ellipse664, _ellipse665, _ellipse666, _ellipse667, _ellipse668, _ellipse669, _ellipse670, _ellipse671, _ellipse672, _ellipse673, _ellipse674, _ellipse675, _ellipse676, _ellipse677, _ellipse678, _ellipse679, _ellipse680, _ellipse681, _ellipse682, _ellipse683, _ellipse684, _ellipse685, _ellipse686, _ellipse687, _ellipse688, _ellipse689, _ellipse690, _ellipse691, _ellipse692, _ellipse693, _ellipse694, _ellipse695, _ellipse696, _ellipse697, _ellipse698, _ellipse699, _ellipse700, _ellipse701, _ellipse702, _ellipse703, _ellipse704, _ellipse705, _ellipse706, _ellipse707, _ellipse708, _ellipse709, _ellipse710, _ellipse711, _ellipse712, _ellipse713, _ellipse714, _ellipse715, _ellipse716, _ellipse717, _ellipse718, _ellipse719, _ellipse720, _ellipse721, _ellipse722, _ellipse723, _ellipse724, _ellipse725, _ellipse726, _ellipse727, _ellipse728, _ellipse729, _ellipse730, _ellipse731, _ellipse732, _ellipse733, _ellipse734, _ellipse735, _ellipse736, _ellipse737, _ellipse738, _ellipse739, _ellipse740, _ellipse741, _ellipse742, _ellipse743, _ellipse744, _ellipse745, _ellipse746, _ellipse747, _ellipse748, _ellipse749, _ellipse750, _ellipse751, _ellipse752, _ellipse753, _ellipse754, _ellipse755, _ellipse756, _ellipse757, _ellipse758, _ellipse759, _ellipse760, _ellipse761, _ellipse762, _ellipse763, _ellipse764, _ellipse765, _ellipse766, _ellipse767, _ellipse768, _ellipse769, _ellipse770, _ellipse771, _ellipse772, _ellipse773, _ellipse774, _ellipse775, _ellipse776, _ellipse777, _ellipse778, _ellipse779, _ellipse780, _ellipse781, _ellipse782, _ellipse783, _ellipse784, _ellipse785, _ellipse786, _ellipse787, _ellipse788, _ellipse789, _ellipse790, _ellipse791, _ellipse792, _ellipse793, _ellipse794, _ellipse795, _ellipse796, _ellipse797, _ellipse798, _ellipse799, _ellipse800, _ellipse801, _ellipse802, _ellipse803, _ellipse804, _ellipse805, _ellipse806, _ellipse807, _ellipse808, _ellipse809, _ellipse810, _ellipse811, _ellipse812, _ellipse813, _ellipse814, _ellipse815, _ellipse816, _ellipse817, _ellipse818, _ellipse819, _ellipse820, _ellipse821, _ellipse822, _ellipse823, _ellipse824, _ellipse825, _ellipse826, _ellipse827, _ellipse828, _ellipse829, _ellipse830, _ellipse831, _ellipse832, _ellipse833, _ellipse834, _ellipse835, _ellipse836, _ellipse837, _ellipse838, _ellipse839, _ellipse840, _ellipse841, _ellipse842, _ellipse843, _ellipse844, _ellipse845, _ellipse846, _ellipse847, _ellipse848, _ellipse849, _ellipse850, _ellipse851, _ellipse852, _ellipse853, _ellipse854, _ellipse855, _ellipse856, _ellipse857, _ellipse858, _ellipse859, _ellipse860, _ellipse861, _ellipse862, _ellipse863, _ellipse864, _ellipse865, _ellipse866, _ellipse867, _ellipse868, _ellipse869, _ellipse870, _ellipse871, _ellipse872, _ellipse873, _ellipse874, _ellipse875, _ellipse876, _ellipse877, _ellipse878, _ellipse879, _ellipse880, _ellipse881, _ellipse882, _ellipse883, _ellipse884, _ellipse885, _ellipse886, _ellipse887, _ellipse888, _ellipse889, _ellipse890, _ellipse891, _ellipse892, _ellipse893, _ellipse894, _ellipse895, _ellipse896, _ellipse897, _ellipse898, _ellipse899, _ellipse900, _ellipse901, _ellipse902, _ellipse903, _ellipse904, _ellipse905, _ellipse906, _ellipse907, _ellipse908, _ellipse909, _ellipse910, _ellipse911, _ellipse912, _ellipse913, _ellipse914, _ellipse915, _ellipse916, _ellipse917, _ellipse918, _ellipse919, _ellipse920, _ellipse921, _ellipse922, _ellipse923, _ellipse924, _ellipse925, _ellipse926, _ellipse927, _ellipse928, _ellipse929, _ellipse930, _ellipse931, _ellipse932, _ellipse933, _ellipse934, _ellipse935, _ellipse936, _ellipse937, _ellipse938, _ellipse939, _ellipse940, _ellipse941, _ellipse942, _ellipse943, _ellipse944, _ellipse945, _ellipse946, _ellipse947, _ellipse948, _ellipse949, _ellipse950, _ellipse951, _ellipse952, _ellipse953, _ellipse954, _ellipse955, _ellipse956, _ellipse957, _ellipse958, _ellipse959, _ellipse960;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointedsquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 172,
    viewBox: "0 0 188 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 171.211,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 164.899,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 158.587,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse116 || (_ellipse116 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse117 || (_ellipse117 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse118 || (_ellipse118 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse119 || (_ellipse119 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse120 || (_ellipse120 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse121 || (_ellipse121 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse122 || (_ellipse122 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse123 || (_ellipse123 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse124 || (_ellipse124 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse125 || (_ellipse125 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse126 || (_ellipse126 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse127 || (_ellipse127 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse128 || (_ellipse128 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 152.275,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse129 || (_ellipse129 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse130 || (_ellipse130 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse131 || (_ellipse131 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse132 || (_ellipse132 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse133 || (_ellipse133 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse134 || (_ellipse134 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse135 || (_ellipse135 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse136 || (_ellipse136 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse137 || (_ellipse137 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse138 || (_ellipse138 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse139 || (_ellipse139 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse140 || (_ellipse140 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse141 || (_ellipse141 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse142 || (_ellipse142 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse143 || (_ellipse143 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse144 || (_ellipse144 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse145 || (_ellipse145 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse146 || (_ellipse146 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse147 || (_ellipse147 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse148 || (_ellipse148 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse149 || (_ellipse149 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse150 || (_ellipse150 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse151 || (_ellipse151 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse152 || (_ellipse152 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse153 || (_ellipse153 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse154 || (_ellipse154 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse155 || (_ellipse155 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse156 || (_ellipse156 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse157 || (_ellipse157 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse158 || (_ellipse158 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse159 || (_ellipse159 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse160 || (_ellipse160 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 145.963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse161 || (_ellipse161 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse162 || (_ellipse162 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse163 || (_ellipse163 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse164 || (_ellipse164 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse165 || (_ellipse165 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse166 || (_ellipse166 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse167 || (_ellipse167 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse168 || (_ellipse168 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse169 || (_ellipse169 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse170 || (_ellipse170 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse171 || (_ellipse171 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse172 || (_ellipse172 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse173 || (_ellipse173 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse174 || (_ellipse174 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse175 || (_ellipse175 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse176 || (_ellipse176 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse177 || (_ellipse177 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse178 || (_ellipse178 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse179 || (_ellipse179 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse180 || (_ellipse180 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse181 || (_ellipse181 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse182 || (_ellipse182 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse183 || (_ellipse183 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse184 || (_ellipse184 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse185 || (_ellipse185 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse186 || (_ellipse186 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse187 || (_ellipse187 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse188 || (_ellipse188 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse189 || (_ellipse189 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse190 || (_ellipse190 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse191 || (_ellipse191 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse192 || (_ellipse192 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 139.651,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse193 || (_ellipse193 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse194 || (_ellipse194 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse195 || (_ellipse195 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse196 || (_ellipse196 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse197 || (_ellipse197 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse198 || (_ellipse198 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse199 || (_ellipse199 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse200 || (_ellipse200 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse201 || (_ellipse201 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse202 || (_ellipse202 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse203 || (_ellipse203 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse204 || (_ellipse204 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse205 || (_ellipse205 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse206 || (_ellipse206 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse207 || (_ellipse207 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse208 || (_ellipse208 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse209 || (_ellipse209 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse210 || (_ellipse210 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse211 || (_ellipse211 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse212 || (_ellipse212 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse213 || (_ellipse213 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse214 || (_ellipse214 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse215 || (_ellipse215 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse216 || (_ellipse216 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse217 || (_ellipse217 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse218 || (_ellipse218 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse219 || (_ellipse219 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse220 || (_ellipse220 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse221 || (_ellipse221 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse222 || (_ellipse222 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse223 || (_ellipse223 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse224 || (_ellipse224 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 133.339,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse225 || (_ellipse225 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse226 || (_ellipse226 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse227 || (_ellipse227 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse228 || (_ellipse228 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse229 || (_ellipse229 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse230 || (_ellipse230 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse231 || (_ellipse231 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse232 || (_ellipse232 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse233 || (_ellipse233 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse234 || (_ellipse234 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse235 || (_ellipse235 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse236 || (_ellipse236 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse237 || (_ellipse237 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse238 || (_ellipse238 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse239 || (_ellipse239 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse240 || (_ellipse240 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse241 || (_ellipse241 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse242 || (_ellipse242 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse243 || (_ellipse243 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse244 || (_ellipse244 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse245 || (_ellipse245 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse246 || (_ellipse246 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse247 || (_ellipse247 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse248 || (_ellipse248 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse249 || (_ellipse249 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse250 || (_ellipse250 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse251 || (_ellipse251 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse252 || (_ellipse252 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse253 || (_ellipse253 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse254 || (_ellipse254 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse255 || (_ellipse255 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse256 || (_ellipse256 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 127.028,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse257 || (_ellipse257 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse258 || (_ellipse258 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse259 || (_ellipse259 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse260 || (_ellipse260 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse261 || (_ellipse261 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse262 || (_ellipse262 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse263 || (_ellipse263 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse264 || (_ellipse264 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse265 || (_ellipse265 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse266 || (_ellipse266 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse267 || (_ellipse267 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse268 || (_ellipse268 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse269 || (_ellipse269 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse270 || (_ellipse270 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse271 || (_ellipse271 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse272 || (_ellipse272 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse273 || (_ellipse273 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse274 || (_ellipse274 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse275 || (_ellipse275 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse276 || (_ellipse276 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse277 || (_ellipse277 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse278 || (_ellipse278 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse279 || (_ellipse279 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse280 || (_ellipse280 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse281 || (_ellipse281 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse282 || (_ellipse282 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse283 || (_ellipse283 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse284 || (_ellipse284 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse285 || (_ellipse285 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse286 || (_ellipse286 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse287 || (_ellipse287 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse288 || (_ellipse288 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 120.716,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse289 || (_ellipse289 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse290 || (_ellipse290 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse291 || (_ellipse291 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse292 || (_ellipse292 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse293 || (_ellipse293 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse294 || (_ellipse294 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse295 || (_ellipse295 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse296 || (_ellipse296 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse297 || (_ellipse297 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse298 || (_ellipse298 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse299 || (_ellipse299 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse300 || (_ellipse300 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse301 || (_ellipse301 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse302 || (_ellipse302 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse303 || (_ellipse303 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse304 || (_ellipse304 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse305 || (_ellipse305 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse306 || (_ellipse306 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse307 || (_ellipse307 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse308 || (_ellipse308 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse309 || (_ellipse309 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse310 || (_ellipse310 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse311 || (_ellipse311 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse312 || (_ellipse312 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse313 || (_ellipse313 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse314 || (_ellipse314 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse315 || (_ellipse315 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse316 || (_ellipse316 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse317 || (_ellipse317 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse318 || (_ellipse318 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse319 || (_ellipse319 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse320 || (_ellipse320 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 114.404,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse321 || (_ellipse321 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse322 || (_ellipse322 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse323 || (_ellipse323 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse324 || (_ellipse324 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse325 || (_ellipse325 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse326 || (_ellipse326 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse327 || (_ellipse327 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse328 || (_ellipse328 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse329 || (_ellipse329 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse330 || (_ellipse330 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse331 || (_ellipse331 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse332 || (_ellipse332 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse333 || (_ellipse333 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse334 || (_ellipse334 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse335 || (_ellipse335 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse336 || (_ellipse336 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse337 || (_ellipse337 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse338 || (_ellipse338 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse339 || (_ellipse339 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse340 || (_ellipse340 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse341 || (_ellipse341 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse342 || (_ellipse342 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse343 || (_ellipse343 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse344 || (_ellipse344 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse345 || (_ellipse345 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse346 || (_ellipse346 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse347 || (_ellipse347 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse348 || (_ellipse348 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse349 || (_ellipse349 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse350 || (_ellipse350 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse351 || (_ellipse351 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse352 || (_ellipse352 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 108.092,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse353 || (_ellipse353 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse354 || (_ellipse354 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse355 || (_ellipse355 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse356 || (_ellipse356 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse357 || (_ellipse357 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse358 || (_ellipse358 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse359 || (_ellipse359 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse360 || (_ellipse360 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse361 || (_ellipse361 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse362 || (_ellipse362 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse363 || (_ellipse363 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse364 || (_ellipse364 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse365 || (_ellipse365 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse366 || (_ellipse366 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse367 || (_ellipse367 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse368 || (_ellipse368 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse369 || (_ellipse369 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse370 || (_ellipse370 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse371 || (_ellipse371 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse372 || (_ellipse372 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse373 || (_ellipse373 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse374 || (_ellipse374 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse375 || (_ellipse375 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse376 || (_ellipse376 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse377 || (_ellipse377 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse378 || (_ellipse378 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse379 || (_ellipse379 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse380 || (_ellipse380 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse381 || (_ellipse381 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse382 || (_ellipse382 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse383 || (_ellipse383 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse384 || (_ellipse384 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 101.78,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse385 || (_ellipse385 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse386 || (_ellipse386 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse387 || (_ellipse387 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse388 || (_ellipse388 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse389 || (_ellipse389 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse390 || (_ellipse390 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse391 || (_ellipse391 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse392 || (_ellipse392 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse393 || (_ellipse393 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse394 || (_ellipse394 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse395 || (_ellipse395 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse396 || (_ellipse396 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse397 || (_ellipse397 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse398 || (_ellipse398 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse399 || (_ellipse399 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse400 || (_ellipse400 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse401 || (_ellipse401 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse402 || (_ellipse402 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse403 || (_ellipse403 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse404 || (_ellipse404 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse405 || (_ellipse405 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse406 || (_ellipse406 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse407 || (_ellipse407 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse408 || (_ellipse408 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse409 || (_ellipse409 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse410 || (_ellipse410 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse411 || (_ellipse411 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse412 || (_ellipse412 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse413 || (_ellipse413 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse414 || (_ellipse414 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse415 || (_ellipse415 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse416 || (_ellipse416 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse417 || (_ellipse417 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse418 || (_ellipse418 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse419 || (_ellipse419 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse420 || (_ellipse420 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse421 || (_ellipse421 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse422 || (_ellipse422 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse423 || (_ellipse423 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse424 || (_ellipse424 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse425 || (_ellipse425 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse426 || (_ellipse426 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse427 || (_ellipse427 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse428 || (_ellipse428 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse429 || (_ellipse429 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse430 || (_ellipse430 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse431 || (_ellipse431 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse432 || (_ellipse432 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse433 || (_ellipse433 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse434 || (_ellipse434 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse435 || (_ellipse435 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse436 || (_ellipse436 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse437 || (_ellipse437 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse438 || (_ellipse438 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse439 || (_ellipse439 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse440 || (_ellipse440 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse441 || (_ellipse441 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse442 || (_ellipse442 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse443 || (_ellipse443 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse444 || (_ellipse444 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse445 || (_ellipse445 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse446 || (_ellipse446 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse447 || (_ellipse447 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse448 || (_ellipse448 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse449 || (_ellipse449 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse450 || (_ellipse450 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse451 || (_ellipse451 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse452 || (_ellipse452 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse453 || (_ellipse453 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse454 || (_ellipse454 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse455 || (_ellipse455 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse456 || (_ellipse456 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse457 || (_ellipse457 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse458 || (_ellipse458 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse459 || (_ellipse459 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse460 || (_ellipse460 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse461 || (_ellipse461 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse462 || (_ellipse462 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse463 || (_ellipse463 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse464 || (_ellipse464 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse465 || (_ellipse465 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse466 || (_ellipse466 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse467 || (_ellipse467 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse468 || (_ellipse468 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse469 || (_ellipse469 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse470 || (_ellipse470 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse471 || (_ellipse471 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse472 || (_ellipse472 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse473 || (_ellipse473 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse474 || (_ellipse474 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse475 || (_ellipse475 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse476 || (_ellipse476 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse477 || (_ellipse477 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse478 || (_ellipse478 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse479 || (_ellipse479 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse480 || (_ellipse480 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 95.4679,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse481 || (_ellipse481 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse482 || (_ellipse482 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse483 || (_ellipse483 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse484 || (_ellipse484 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse485 || (_ellipse485 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse486 || (_ellipse486 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse487 || (_ellipse487 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse488 || (_ellipse488 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse489 || (_ellipse489 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse490 || (_ellipse490 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse491 || (_ellipse491 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse492 || (_ellipse492 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse493 || (_ellipse493 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse494 || (_ellipse494 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse495 || (_ellipse495 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse496 || (_ellipse496 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse497 || (_ellipse497 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse498 || (_ellipse498 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse499 || (_ellipse499 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse500 || (_ellipse500 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse501 || (_ellipse501 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse502 || (_ellipse502 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse503 || (_ellipse503 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse504 || (_ellipse504 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse505 || (_ellipse505 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse506 || (_ellipse506 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse507 || (_ellipse507 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse508 || (_ellipse508 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse509 || (_ellipse509 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse510 || (_ellipse510 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse511 || (_ellipse511 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse512 || (_ellipse512 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 89.156,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse513 || (_ellipse513 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse514 || (_ellipse514 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse515 || (_ellipse515 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse516 || (_ellipse516 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse517 || (_ellipse517 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse518 || (_ellipse518 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse519 || (_ellipse519 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse520 || (_ellipse520 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse521 || (_ellipse521 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse522 || (_ellipse522 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse523 || (_ellipse523 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse524 || (_ellipse524 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse525 || (_ellipse525 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse526 || (_ellipse526 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse527 || (_ellipse527 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse528 || (_ellipse528 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse529 || (_ellipse529 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse530 || (_ellipse530 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse531 || (_ellipse531 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse532 || (_ellipse532 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse533 || (_ellipse533 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse534 || (_ellipse534 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse535 || (_ellipse535 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse536 || (_ellipse536 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse537 || (_ellipse537 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse538 || (_ellipse538 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse539 || (_ellipse539 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse540 || (_ellipse540 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse541 || (_ellipse541 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse542 || (_ellipse542 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse543 || (_ellipse543 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse544 || (_ellipse544 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 82.844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse545 || (_ellipse545 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse546 || (_ellipse546 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse547 || (_ellipse547 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse548 || (_ellipse548 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse549 || (_ellipse549 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse550 || (_ellipse550 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse551 || (_ellipse551 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse552 || (_ellipse552 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse553 || (_ellipse553 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse554 || (_ellipse554 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse555 || (_ellipse555 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse556 || (_ellipse556 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse557 || (_ellipse557 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse558 || (_ellipse558 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse559 || (_ellipse559 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse560 || (_ellipse560 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse561 || (_ellipse561 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse562 || (_ellipse562 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse563 || (_ellipse563 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse564 || (_ellipse564 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse565 || (_ellipse565 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse566 || (_ellipse566 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse567 || (_ellipse567 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse568 || (_ellipse568 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse569 || (_ellipse569 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse570 || (_ellipse570 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse571 || (_ellipse571 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse572 || (_ellipse572 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse573 || (_ellipse573 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse574 || (_ellipse574 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse575 || (_ellipse575 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse576 || (_ellipse576 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 76.5321,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse577 || (_ellipse577 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse578 || (_ellipse578 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse579 || (_ellipse579 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse580 || (_ellipse580 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse581 || (_ellipse581 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse582 || (_ellipse582 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse583 || (_ellipse583 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse584 || (_ellipse584 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse585 || (_ellipse585 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse586 || (_ellipse586 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse587 || (_ellipse587 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse588 || (_ellipse588 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse589 || (_ellipse589 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse590 || (_ellipse590 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse591 || (_ellipse591 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse592 || (_ellipse592 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse593 || (_ellipse593 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse594 || (_ellipse594 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse595 || (_ellipse595 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse596 || (_ellipse596 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse597 || (_ellipse597 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse598 || (_ellipse598 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse599 || (_ellipse599 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse600 || (_ellipse600 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse601 || (_ellipse601 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse602 || (_ellipse602 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse603 || (_ellipse603 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse604 || (_ellipse604 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse605 || (_ellipse605 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse606 || (_ellipse606 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse607 || (_ellipse607 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse608 || (_ellipse608 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 70.2202,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse609 || (_ellipse609 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse610 || (_ellipse610 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse611 || (_ellipse611 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse612 || (_ellipse612 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse613 || (_ellipse613 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse614 || (_ellipse614 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse615 || (_ellipse615 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse616 || (_ellipse616 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse617 || (_ellipse617 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse618 || (_ellipse618 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse619 || (_ellipse619 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse620 || (_ellipse620 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse621 || (_ellipse621 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse622 || (_ellipse622 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse623 || (_ellipse623 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse624 || (_ellipse624 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse625 || (_ellipse625 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse626 || (_ellipse626 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse627 || (_ellipse627 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse628 || (_ellipse628 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse629 || (_ellipse629 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse630 || (_ellipse630 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse631 || (_ellipse631 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse632 || (_ellipse632 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse633 || (_ellipse633 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse634 || (_ellipse634 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse635 || (_ellipse635 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse636 || (_ellipse636 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse637 || (_ellipse637 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse638 || (_ellipse638 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse639 || (_ellipse639 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse640 || (_ellipse640 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 63.9083,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse641 || (_ellipse641 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse642 || (_ellipse642 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse643 || (_ellipse643 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse644 || (_ellipse644 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse645 || (_ellipse645 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse646 || (_ellipse646 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse647 || (_ellipse647 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse648 || (_ellipse648 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse649 || (_ellipse649 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse650 || (_ellipse650 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse651 || (_ellipse651 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse652 || (_ellipse652 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse653 || (_ellipse653 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse654 || (_ellipse654 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse655 || (_ellipse655 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse656 || (_ellipse656 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse657 || (_ellipse657 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse658 || (_ellipse658 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse659 || (_ellipse659 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse660 || (_ellipse660 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse661 || (_ellipse661 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse662 || (_ellipse662 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse663 || (_ellipse663 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse664 || (_ellipse664 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse665 || (_ellipse665 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse666 || (_ellipse666 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse667 || (_ellipse667 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse668 || (_ellipse668 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse669 || (_ellipse669 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse670 || (_ellipse670 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse671 || (_ellipse671 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse672 || (_ellipse672 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 57.5963,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse673 || (_ellipse673 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse674 || (_ellipse674 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse675 || (_ellipse675 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse676 || (_ellipse676 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse677 || (_ellipse677 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse678 || (_ellipse678 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse679 || (_ellipse679 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse680 || (_ellipse680 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse681 || (_ellipse681 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse682 || (_ellipse682 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse683 || (_ellipse683 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse684 || (_ellipse684 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse685 || (_ellipse685 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse686 || (_ellipse686 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse687 || (_ellipse687 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse688 || (_ellipse688 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse689 || (_ellipse689 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse690 || (_ellipse690 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse691 || (_ellipse691 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse692 || (_ellipse692 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse693 || (_ellipse693 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse694 || (_ellipse694 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse695 || (_ellipse695 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse696 || (_ellipse696 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse697 || (_ellipse697 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse698 || (_ellipse698 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse699 || (_ellipse699 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse700 || (_ellipse700 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse701 || (_ellipse701 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse702 || (_ellipse702 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse703 || (_ellipse703 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse704 || (_ellipse704 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 51.2844,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse705 || (_ellipse705 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse706 || (_ellipse706 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse707 || (_ellipse707 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse708 || (_ellipse708 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse709 || (_ellipse709 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse710 || (_ellipse710 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse711 || (_ellipse711 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse712 || (_ellipse712 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse713 || (_ellipse713 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse714 || (_ellipse714 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse715 || (_ellipse715 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse716 || (_ellipse716 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse717 || (_ellipse717 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse718 || (_ellipse718 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse719 || (_ellipse719 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse720 || (_ellipse720 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse721 || (_ellipse721 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse722 || (_ellipse722 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse723 || (_ellipse723 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse724 || (_ellipse724 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse725 || (_ellipse725 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse726 || (_ellipse726 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse727 || (_ellipse727 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse728 || (_ellipse728 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse729 || (_ellipse729 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse730 || (_ellipse730 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse731 || (_ellipse731 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse732 || (_ellipse732 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse733 || (_ellipse733 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse734 || (_ellipse734 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse735 || (_ellipse735 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse736 || (_ellipse736 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 44.9725,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse737 || (_ellipse737 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse738 || (_ellipse738 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse739 || (_ellipse739 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse740 || (_ellipse740 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse741 || (_ellipse741 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse742 || (_ellipse742 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse743 || (_ellipse743 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse744 || (_ellipse744 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse745 || (_ellipse745 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse746 || (_ellipse746 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse747 || (_ellipse747 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse748 || (_ellipse748 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse749 || (_ellipse749 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse750 || (_ellipse750 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse751 || (_ellipse751 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse752 || (_ellipse752 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse753 || (_ellipse753 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse754 || (_ellipse754 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse755 || (_ellipse755 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse756 || (_ellipse756 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse757 || (_ellipse757 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse758 || (_ellipse758 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse759 || (_ellipse759 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse760 || (_ellipse760 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse761 || (_ellipse761 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse762 || (_ellipse762 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse763 || (_ellipse763 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse764 || (_ellipse764 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse765 || (_ellipse765 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse766 || (_ellipse766 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse767 || (_ellipse767 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse768 || (_ellipse768 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 38.6605,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse769 || (_ellipse769 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse770 || (_ellipse770 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse771 || (_ellipse771 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse772 || (_ellipse772 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse773 || (_ellipse773 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse774 || (_ellipse774 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse775 || (_ellipse775 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse776 || (_ellipse776 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse777 || (_ellipse777 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse778 || (_ellipse778 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse779 || (_ellipse779 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse780 || (_ellipse780 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse781 || (_ellipse781 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse782 || (_ellipse782 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse783 || (_ellipse783 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse784 || (_ellipse784 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse785 || (_ellipse785 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse786 || (_ellipse786 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse787 || (_ellipse787 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse788 || (_ellipse788 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse789 || (_ellipse789 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse790 || (_ellipse790 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse791 || (_ellipse791 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse792 || (_ellipse792 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse793 || (_ellipse793 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse794 || (_ellipse794 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse795 || (_ellipse795 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse796 || (_ellipse796 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse797 || (_ellipse797 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse798 || (_ellipse798 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse799 || (_ellipse799 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse800 || (_ellipse800 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 32.3486,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse801 || (_ellipse801 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse802 || (_ellipse802 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse803 || (_ellipse803 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse804 || (_ellipse804 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse805 || (_ellipse805 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse806 || (_ellipse806 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse807 || (_ellipse807 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse808 || (_ellipse808 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse809 || (_ellipse809 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse810 || (_ellipse810 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse811 || (_ellipse811 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse812 || (_ellipse812 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse813 || (_ellipse813 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse814 || (_ellipse814 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse815 || (_ellipse815 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse816 || (_ellipse816 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse817 || (_ellipse817 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse818 || (_ellipse818 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse819 || (_ellipse819 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse820 || (_ellipse820 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse821 || (_ellipse821 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse822 || (_ellipse822 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse823 || (_ellipse823 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse824 || (_ellipse824 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse825 || (_ellipse825 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse826 || (_ellipse826 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse827 || (_ellipse827 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse828 || (_ellipse828 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse829 || (_ellipse829 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse830 || (_ellipse830 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse831 || (_ellipse831 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse832 || (_ellipse832 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 26.0367,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse833 || (_ellipse833 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse834 || (_ellipse834 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse835 || (_ellipse835 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse836 || (_ellipse836 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse837 || (_ellipse837 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse838 || (_ellipse838 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse839 || (_ellipse839 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse840 || (_ellipse840 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse841 || (_ellipse841 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse842 || (_ellipse842 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse843 || (_ellipse843 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse844 || (_ellipse844 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse845 || (_ellipse845 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse846 || (_ellipse846 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse847 || (_ellipse847 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse848 || (_ellipse848 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse849 || (_ellipse849 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse850 || (_ellipse850 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse851 || (_ellipse851 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse852 || (_ellipse852 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse853 || (_ellipse853 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse854 || (_ellipse854 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse855 || (_ellipse855 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse856 || (_ellipse856 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse857 || (_ellipse857 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse858 || (_ellipse858 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse859 || (_ellipse859 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse860 || (_ellipse860 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse861 || (_ellipse861 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse862 || (_ellipse862 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse863 || (_ellipse863 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse864 || (_ellipse864 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 19.7248,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse865 || (_ellipse865 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse866 || (_ellipse866 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse867 || (_ellipse867 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse868 || (_ellipse868 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse869 || (_ellipse869 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse870 || (_ellipse870 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse871 || (_ellipse871 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse872 || (_ellipse872 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse873 || (_ellipse873 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse874 || (_ellipse874 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse875 || (_ellipse875 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse876 || (_ellipse876 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse877 || (_ellipse877 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse878 || (_ellipse878 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse879 || (_ellipse879 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse880 || (_ellipse880 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse881 || (_ellipse881 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse882 || (_ellipse882 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse883 || (_ellipse883 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse884 || (_ellipse884 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse885 || (_ellipse885 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse886 || (_ellipse886 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse887 || (_ellipse887 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse888 || (_ellipse888 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse889 || (_ellipse889 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse890 || (_ellipse890 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse891 || (_ellipse891 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse892 || (_ellipse892 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse893 || (_ellipse893 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse894 || (_ellipse894 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse895 || (_ellipse895 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse896 || (_ellipse896 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 13.4128,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse897 || (_ellipse897 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse898 || (_ellipse898 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse899 || (_ellipse899 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse900 || (_ellipse900 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse901 || (_ellipse901 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse902 || (_ellipse902 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse903 || (_ellipse903 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse904 || (_ellipse904 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse905 || (_ellipse905 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse906 || (_ellipse906 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse907 || (_ellipse907 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse908 || (_ellipse908 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse909 || (_ellipse909 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse910 || (_ellipse910 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse911 || (_ellipse911 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse912 || (_ellipse912 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse913 || (_ellipse913 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse914 || (_ellipse914 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse915 || (_ellipse915 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse916 || (_ellipse916 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse917 || (_ellipse917 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse918 || (_ellipse918 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse919 || (_ellipse919 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse920 || (_ellipse920 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse921 || (_ellipse921 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse922 || (_ellipse922 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse923 || (_ellipse923 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse924 || (_ellipse924 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse925 || (_ellipse925 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse926 || (_ellipse926 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse927 || (_ellipse927 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse928 || (_ellipse928 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 7.10091,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse929 || (_ellipse929 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.752,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse930 || (_ellipse930 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.76799,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse931 || (_ellipse931 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.784,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse932 || (_ellipse932 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse933 || (_ellipse933 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.816,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse934 || (_ellipse934 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.832,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse935 || (_ellipse935 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.8479,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse936 || (_ellipse936 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8641,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse937 || (_ellipse937 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8801,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse938 || (_ellipse938 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.896,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse939 || (_ellipse939 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.912,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse940 || (_ellipse940 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.928,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse941 || (_ellipse941 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.944,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse942 || (_ellipse942 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.96,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse943 || (_ellipse943 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.976,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse944 || (_ellipse944 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.992,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse945 || (_ellipse945 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse946 || (_ellipse946 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.024,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse947 || (_ellipse947 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.04,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse948 || (_ellipse948 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.056,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse949 || (_ellipse949 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.072,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse950 || (_ellipse950 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.088,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse951 || (_ellipse951 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.104,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse952 || (_ellipse952 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.12,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse953 || (_ellipse953 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.136,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse954 || (_ellipse954 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.152,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse955 || (_ellipse955 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.168,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse956 || (_ellipse956 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.184,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse957 || (_ellipse957 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.2,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse958 || (_ellipse958 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.216,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse959 || (_ellipse959 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.232,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })), _ellipse960 || (_ellipse960 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.248,
    cy: 0.788991,
    rx: 0.752,
    ry: 0.788991,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointedsquare);
export default __webpack_public_path__ + "static/media/pointed square.adee2876c54dde5e1e76256b30eadd04.svg";
export { ForwardRef as ReactComponent };